<template>
  <v-icon :color="color">{{ `mdi-numeric-${number}-box` }}</v-icon>
</template>
<script setup>
const props = defineProps(['number', 'color']);
</script>
<style></style>
